import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useRef } from "react";
import { db } from "../data/base";
import { doc, getDoc } from "firebase/firestore";
import { Button } from "antd";
import { useLocation } from "react-router-dom";

import { modelGlassesActions } from "../redux/brandViewer/modelGlasses";
import { brandViewerActions } from "../redux/brandViewer/brandViewer";
import ModelContainerFrontEnd from "../components/ModelViewer/ModelContainerFrontEnd";
import ThreeJSViewer from "../components/ModelViewer/ThreeJSViewer/ThreeJSViewer";

function Renderer() {
    const params = useParams();
    const dispatch = useDispatch();

    const variantId = params.TokenVariant;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const templateConfig = JSON.parse(queryParams.get("templateConfig"));
    console.log("templateConfig", JSON.stringify(templateConfig));

    // Stato per gestire gli errori
    const [error, setError] = useState(null);

    const modelInView = useSelector((state) =>
        state.modelGlasses.find((modelState) => modelState.id === variantId)
    );

    // Stati aggiuntivi
    const [src, setSrc] = useState("");
    const [usdzSrc, setUsdzSrc] = useState(null);
    const skuModel = useRef(null);

    // Riferimento al ThreeJSViewer
    const viewer = useRef();

    const PROJECT_PARAMS = {
        ar: "true",
        autoRotate: false,
        backgroundColor: templateConfig?.background_color || "#ffffff",
        isBackgroundImage: false,
        backgroundImage: "",
        cameraControls: true,
        cameraOrbit: "",
        disableZoom: false,
        exposure: templateConfig?.light_exposition || 1,
        lightExposition: templateConfig?.light_exposition || 1,
        shadowIntensity: 0.5,
        shadowSmooth: 0.3,
    };

    const RENDER_OPTIONS = {
        cameraFov: templateConfig?.camera_fov,
        cameraPosition: templateConfig?.camera_position,
        cameraRotation: templateConfig?.camera_rotation,
        cameraLookAt: templateConfig?.camera_look_at,
        download: false,
    };

    // useEffect: carica i dati del modello e imposta altre variabili
    useEffect(() => {
        async function fetchModelData() {
            try {
                const variantDoc = await getDoc(doc(db, "Variants", variantId));
                if (variantDoc && variantDoc.exists() && variantDoc.data()) {
                    const data = variantDoc.data();
                    data.lastUpdate = data.lastUpdate.toDate().toISOString();
                    dispatch(modelGlassesActions.setModel({ data, id: variantId }));
                    setSrc(data.urlGlobalComplete);
                    setUsdzSrc(data.urlUsdzComplete);
                    dispatch(brandViewerActions.setSelectedProject(PROJECT_PARAMS));
                    // console.log("data.skuModel", data.skuModel);
                    skuModel.current = data.skuModel;
                } else {
                    console.error("Variant not found");
                    setError("Error during model data loading: variant not found");
                }
            } catch (error) {
                console.error(
                    "Error during model data loading: ",
                    error
                );
                setError(error.message);
            }
        }
        fetchModelData();
    }, [variantId, dispatch]);

    window.triggerServerRender = async (params) => {
        console.log("Triggering Server Render...");
        console.log("params", JSON.stringify(params));
        return await viewer.current.onRender(
            skuModel.current,
            params.width,
            params.height,
            RENDER_OPTIONS
        );
    };

    return (
        <div>
            {error && (
                <div
                    style={{
                        backgroundColor: "#f8d7da",
                        color: "#721c24",
                        padding: "10px",
                        borderRadius: "5px",
                        margin: "10px 0",
                        textAlign: "center",
                    }}
                >
                    {error}
                </div>
            )}

            {/* Bottone per effettuare il render e scaricare uno screenshot */}
            <div
                id="renderer-container"
                style={{
                    position: "absolute",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    top: "20px",
                    right: "40px",
                    zIndex: 1000,
                    backgroundColor: "transparent",
                    borderRadius: "1px",
                    padding: "10px",
                    cursor: "pointer",
                    width: "100px",
                    height: "40px",
                    fontSize: "16px",
                    fontWeight: "bolder",
                    color: "black",
                }}
            >
                <Button
                    onClick={() =>
                        viewer.current.onRender(skuModel.current, 1872, 872, {...RENDER_OPTIONS, download: true})
                    }
                >
                    RENDER NOW
                </Button>
            </div>

            <ModelContainerFrontEnd
                modelSelected={modelInView}
                project={PROJECT_PARAMS}
                singleView
            >
                {!navigator.userAgent.match(/FBAV/i) && (
                    <>
                        <ThreeJSViewer
                            ref={viewer}
                            singleView
                            singleSrc={src}
                            singleUsdzSrc={usdzSrc}
                            viewerPage
                            paramsId={params.token}
                            isRenderer
                        />
                    </>
                )}
            </ModelContainerFrontEnd>
        </div>
    );
}

export default Renderer;
